//      
import {               } from 'css-box-model';

// Not guarenteed to scroll by the entire amount
export default (change          )       => {
  window.scrollBy(change.x, change.y);
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/window/scroll-window.js